module.exports = __webpack_public_path__ + "img/洛阳润宝研磨材料有限公司.e19437a0.jpg";